<script>
    import {COMPANY_NAME} from "../../class/business/Constants";
    import { t } from "../../i18n";

    export let online = true;
    export let name = COMPANY_NAME;
</script>
<a class="media-left" href="JavaScript:void(0);">
    <div class="avatar mr-75">
        <i class="bx bx-user" style="font-size: 4em;"></i>
        <span class="avatar-status-{online?'online':'offline'}"></span>
    </div>
</a>
<div class="media-body">
    <h6 class="media-heading mb-0 pt-25"><a href="javaScript:void(0);">{name}</a></h6>
    {#if online}<span class="text-muted font-small-3">{$t('chat.active')}</span>{/if}
</div>